import { plural, t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Accordion, AccordionItem, Alert, Box, Button, EmptyState, IconButton, LoaderOverlay } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useHistory } from 'react-router-dom';
import { ManageProjectsMenu } from 'app/domains/projects/components/ManageProjectsMenu';
import { DocumentDrawerHeader, useActiveDocument } from 'shared/domains/documents';
import { DocumentItem } from './DocumentItem';
import { useDocumentProjects } from './useDocumentProjects';
import { DrawerContainer } from '../../styled';
import { getTitle } from '../../utils';
import { Container } from './styled';
export function Projects(props) {
    const { onClose, onGoBack } = props;
    const { projects, loading, error } = useDocumentProjects();
    const { id: documentId } = useActiveDocument();
    const title = getTitle('projects');
    const history = useHistory();
    const getProjectSubtitle = (amount) => t({
        message: plural(amount, {
            one: '# document',
            other: '# documents',
        }),
        comment: 'Document settings - Projects list item subtitle',
    });
    const goToProject = (projectId) => {
        history.push(`/projects/${projectId}`);
    };
    if (loading) {
        return (<DrawerContainer>
        <DocumentDrawerHeader type="nested" title={title} onClose={onClose} onGoBack={onGoBack}/>
        <LoaderOverlay enabled label={t({
                comment: 'Loading document projects label',
                message: 'Loading projects...',
            })}/>
      </DrawerContainer>);
    }
    if (error) {
        return (<DrawerContainer>
        <DocumentDrawerHeader type="nested" title={title} onClose={onClose} onGoBack={onGoBack}/>
        <Box p="2xl">
          <Alert appearance="danger" message={t({
                comment: 'Loading document projects error message',
                message: 'Could not load projects',
            })}/>
        </Box>
      </DrawerContainer>);
    }
    return (<DrawerContainer>
      <DocumentDrawerHeader type="nested" title={title} onClose={onClose} onGoBack={onGoBack}/>

      <Container>
        <Box display="block" width="100%" px="2xl" pt="2xl">
          <ManageProjectsMenu documentId={documentId} renderTarget={<Button $stretch appearance="secondary">
                <Trans comment="Document settings - Projects list - Manage projects button label">
                  Manage projects
                </Trans>
              </Button>}/>
        </Box>

        {projects.length > 0 && (<Accordion>
            {projects.map((project) => (<AccordionItem key={project.id} value={project.id} title={project.name} subtitle={getProjectSubtitle(project.documents.length)} endElement={<IconButton size="xs" appearance="secondary" onClick={() => goToProject(project.id)} aria-label={t({
                        message: 'Go to project',
                        comment: 'Document settings - Projects list item go to project tooltip',
                    })}>
                    <Falcon icon="arrow-right"/>
                  </IconButton>}>
                {project.documents.map((document) => (<DocumentItem key={document.id} {...document}/>))}
              </AccordionItem>))}
          </Accordion>)}

        {projects.length === 0 && (<EmptyState withAvatar icon={<Falcon icon="rectangle-history"/>} title={t({
                message: 'No projects',
                comment: 'Document settings - Projects list - empty state title',
            })} description={t({
                message: 'This document is not included in any project',
                comment: 'Document settings - Projects list - empty state description',
            })}/>)}
      </Container>
    </DrawerContainer>);
}
